module.exports = __webpack_public_path__ + "static/media/206-header3.72bc4190.jpg";